var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckedSquare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "12px",
    viewBox: "0 0 13.0 12.0",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "i0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1920,0 L1920,1036 L0,1036 L0,0 L1920,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.7383534,0.135378531 C11.9507209,-0.0636535617 12.282513,-0.037179305 12.4682827,0.175086598 C12.6408407,0.374206377 12.6408407,0.666191052 12.4683753,0.891794567 L12.4551372,0.905032643 C11.7782437,1.67477918 11.1146691,2.49758799 10.4776612,3.33371569 C9.85387734,4.16979599 9.23011721,5.01917148 8.65949045,5.89511366 C7.50489434,7.63367911 5.72645279,10.9250091 5.52741832,11.2966109 C5.34152264,11.6549649 5.02307793,12 4.43910858,12 C3.84191513,12 3.54993283,11.6416342 3.41717999,11.4160307 C3.28446507,11.1771438 0.0727639926,5.64293161 0.0727639926,5.64293161 C-0.0732271598,5.39086805 0.00637809341,5.07230959 0.258560142,4.92631843 C0.470927713,4.79366039 0.736338595,4.84670607 0.895568061,5.01926391 L4.26652704,8.64238124 C5.19553149,7.31523203 6.19089339,6.02784991 7.22606977,4.79364854 C7.92945885,3.97083973 8.65941461,3.17459761 9.40259447,2.39150848 C10.1591169,1.60851415 10.9155446,0.8520865 11.7383534,0.135378531 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1061.0 -566.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(698.0 531.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(358.0 30.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.999999999999977 5.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i1)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "5.55111512e-17,0 12.5977127,0 12.5977127,12 5.55111512e-17,12 5.55111512e-17,0",
    stroke: "none",
    fill: "#000000"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedSquare);
export default __webpack_public_path__ + "static/media/checked-square.2e4e1809488b3406c87f8591ce3cdac3.svg";
export { ForwardRef as ReactComponent };